import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { EntitySelector } from "./entitySelector";
/**
 * A primitive component with a ComboBox for selecting from existing scene skeletons.
 * @param props SkeletonSelectorProps
 * @returns SkeletonSelector component
 */
export const SkeletonSelector = (props) => {
    SkeletonSelector.displayName = "SkeletonSelector";
    const { scene, ...rest } = props;
    const getSkeletons = useCallback(() => scene.skeletons, [scene.skeletons]);
    const getName = useCallback((skeleton) => skeleton.name, []);
    return _jsx(EntitySelector, { ...rest, getEntities: getSkeletons, getName: getName });
};
//# sourceMappingURL=skeletonSelector.js.map